
import Component from "vue-class-component";
import {Vue} from "vue-property-decorator";
import securityPolicy from "@/assets/data/security-policy/security-policy.json";
import PageHero from "@/components/UI/renewal/PageHero.vue";
import BrandButton from "@/components/UI/renewal/BrandButton.vue";

@Component({
  components: {PageHero, BrandButton}
})
export default class SecurityPolicyContent extends Vue {
  private policies = securityPolicy.policies;
  private contact = securityPolicy.contact;
  private enacted = securityPolicy.enacted;
}
